<template>
  <Navbar />
   <div class="">
    <div class="mx-auto max-w-2xl pt-16 sm:px-6 sm:py-24 lg:max-w-7xl lg:px-8">
      <div class="space-y-2 px-4 sm:flex sm:items-baseline sm:justify-between sm:space-y-0 sm:px-0">
        <div class="flex sm:items-baseline sm:space-x-4">
          <h1 class="text-2xl font-bold tracking-tight text-white sm:text-3xl">Order #54879</h1>
          <a href="#" class="hidden text-sm font-medium text-emerald-600 hover:text-emerald-500 sm:block">
            View invoice
            <span aria-hidden="true"> &rarr;</span>
          </a>
        </div>
        <p class="text-sm text-gray-400">Order placed <time datetime="2021-03-22" class="font-medium text-white">March 22, 2021</time></p>
        <a href="#" class="text-sm font-medium text-emerald-600 hover:text-emerald-500 sm:hidden">
          View invoice
          <span aria-hidden="true"> &rarr;</span>
        </a>
      </div>

      <!-- Products -->
      <div class="mt-6">
        <h2 class="sr-only">Products purchased</h2>

        <div class="space-y-8">
          <div v-for="product in products" :key="product.id" class=" bg-gray-800 shadow-xs sm:rounded-lg ">
            <div class="px-4 py-6 sm:px-6 lg:grid lg:grid-cols-12 lg:gap-x-8 lg:p-8">
              <div class="sm:flex lg:col-span-7">
                <img :src="product.imageSrc" :alt="product.imageAlt" class="aspect-square w-full shrink-0 rounded-lg object-cover sm:size-40" />

                <div class="mt-6 sm:mt-0 sm:ml-6">
                  <h3 class="text-base font-medium text-white">
                    <a :href="product.href">{{ product.name }}</a>
                  </h3>
                  <p class="mt-2 text-sm font-medium text-white">${{ product.price }}</p>
                  <p class="mt-3 text-sm text-gray-400">{{ product.description }}</p>
                </div>
              </div>

              <div class="mt-6 lg:col-span-5 lg:mt-0">
                <dl class="grid grid-cols-2 gap-x-6 text-sm">
                  <div>
                    <dt class="font-medium text-white">Delivery address</dt>
                    <dd class="mt-3 text-gray-400">
                      <span class="block">{{ product.address[0] }}</span>
                      <span class="block">{{ product.address[1] }}</span>
                      <span class="block">{{ product.address[2] }}</span>
                    </dd>
                  </div>
                  <div>
                    <dt class="font-medium text-white">Shipping updates</dt>
                    <dd class="mt-3 space-y-3 text-gray-400">
                      <p>{{ product.email }}</p>
                      <p>{{ product.phone }}</p>
                      <button type="button" class="font-medium text-emerald-600 hover:text-emerald-500">Edit</button>
                    </dd>
                  </div>
                </dl>
              </div>
            </div>

            <div class="border-t border-gray-200 px-4 py-6 sm:px-6 lg:p-8">
              <h4 class="sr-only">Status</h4>
              <p class="text-sm font-medium text-white">
                {{ product.status }} on <time :datetime="product.datetime">{{ product.date }}</time>
              </p>
              <div class="mt-6" aria-hidden="true">
                <div class="overflow-hidden rounded-full bg-gray-200">
                  <div class="h-2 rounded-full bg-emerald-600" :style="{ width: `calc((${product.step} * 2 + 1) / 8 * 100%)` }" />
                </div>
                <div class="mt-6 hidden grid-cols-4 text-sm font-medium text-gray-400 sm:grid">
                  <div class="text-emerald-600">Order placed</div>
                  <div :class="[product.step > 0 ? 'text-emerald-600' : '', 'text-center']">Processing</div>
                  <div :class="[product.step > 1 ? 'text-emerald-600' : '', 'text-center']">Shipped</div>
                  <div :class="[product.step > 2 ? 'text-emerald-600' : '', 'text-right']">Delivered</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Billing -->
      <div class="mt-16">
        <h2 class="sr-only">Billing Summary</h2>

        <div class="bg-gray-700 px-4 py-6 sm:rounded-lg sm:px-6 lg:grid lg:grid-cols-12 lg:gap-x-8 lg:px-8 lg:py-8">
          <dl class="grid grid-cols-2 gap-6 text-sm sm:grid-cols-2 md:gap-x-8 lg:col-span-7">
            <div>
              <dt class="font-medium text-white">Billing address</dt>
              <dd class="mt-3 text-gray-400">
                <span class="block">Floyd Miles</span>
                <span class="block">7363 Cynthia Pass</span>
                <span class="block">Toronto, ON N3Y 4H8</span>
              </dd>
            </div>
            <div>
              <dt class="font-medium text-white">Payment information</dt>
              <dd class="-mt-1 -ml-4 flex flex-wrap">
                <div class="mt-4 ml-4 shrink-0">
                  <svg aria-hidden="true" width="36" height="24" viewBox="0 0 36 24" class="h-6 w-auto">
                    <rect width="36" height="24" rx="4" fill="#224DBA" />
                    <path d="M10.925 15.673H8.874l-1.538-6c-.073-.276-.228-.52-.456-.635A6.575 6.575 0 005 8.403v-.231h3.304c.456 0 .798.347.855.75l.798 4.328 2.05-5.078h1.994l-3.076 7.5zm4.216 0h-1.937L14.8 8.172h1.937l-1.595 7.5zm4.101-5.422c.057-.404.399-.635.798-.635a3.54 3.54 0 011.88.346l.342-1.615A4.808 4.808 0 0020.496 8c-1.88 0-3.248 1.039-3.248 2.481 0 1.097.969 1.673 1.653 2.02.74.346 1.025.577.968.923 0 .519-.57.75-1.139.75a4.795 4.795 0 01-1.994-.462l-.342 1.616a5.48 5.48 0 002.108.404c2.108.057 3.418-.981 3.418-2.539 0-1.962-2.678-2.077-2.678-2.942zm9.457 5.422L27.16 8.172h-1.652a.858.858 0 00-.798.577l-2.848 6.924h1.994l.398-1.096h2.45l.228 1.096h1.766zm-2.905-5.482l.57 2.827h-1.596l1.026-2.827z" fill="#fff" />
                  </svg>
                  <p class="sr-only">Visa</p>
                </div>
                <div class="mt-4 ml-4">
                  <p class="text-white">Ending with 4242</p>
                  <p class="text-gray-500">Expires 02 / 24</p>
                </div>
              </dd>
            </div>
          </dl>

          <dl class="mt-8 divide-y divide-gray-200 text-sm lg:col-span-5 lg:mt-0">
            <div class="flex items-center justify-between pb-4">
              <dt class="text-gray-400">Subtotal</dt>
              <dd class="font-medium text-white">$72</dd>
            </div>
            <div class="flex items-center justify-between py-4">
              <dt class="text-gray-400">Shipping</dt>
              <dd class="font-medium text-white">$5</dd>
            </div>
            <div class="flex items-center justify-between py-4">
              <dt class="text-gray-400">Tax</dt>
              <dd class="font-medium text-white">$6.16</dd>
            </div>
            <div class="flex items-center justify-between pt-4">
              <dt class="font-medium text-white">Order total</dt>
              <dd class="font-medium text-emerald-600">$83.16</dd>
            </div>
          </dl>
        </div>
      </div>
    </div>
  </div>
  <v-card>
    <v-card-title>Recent Orders</v-card-title>
    <v-data-table
      :headers="headers"
      :items="orders"
      item-key="id"
      :loading="loading"
      class="elevation-1 custom-table"
    >
      <template #[`item.status`]="{ item }">
        <v-chip
          :color="getStatusColor(item.status)"
          dark
        >
          {{ item.status }}
        </v-chip>
      </template>
      <template #[`item.created_at`]="{ item }">
        <span>{{ formatDate(item.created_at) }}</span>
      </template>
    </v-data-table>
  </v-card>
</template>
  
<script setup>
import Navbar from '@/components/Navbar.vue'
import { ref, onMounted } from 'vue';
import axios from 'axios';

// Data variables
const orders = ref([]);
const loading = ref(true);
const headers = [
  { title: 'Order ID', align: 'start', key: 'id' },
  { title: 'Date', align: 'start', key: 'created_at' },
  { title: 'Total Price', align: 'start', key: 'total_price' },
  { title: 'Status', align: 'start', key: 'status' },
];

// Fetch Orders
const fetchOrders = async () => {
  try {
    const API_URL = import.meta.env.VITE_API_URL; // Use `import.meta.env` for environment variables in Vite
    const response = await axios.get(`${API_URL}/api/user/orders`);
    orders.value = response.data;
  } catch (error) {
    console.error('There was an error fetching the orders:', error);
  } finally {
    loading.value = false;
  }
};

// Status color function
const getStatusColor = (status) => {
  switch (status) {
    case 'pending':
      return 'orange';
    case 'active':
      return 'green';
    case 'deleted':
      return 'red';
    default:
      return 'blue';
  }
};

// Format date function
const formatDate = (date) => {
  return new Date(date).toLocaleDateString();
};

// Fetch orders on component mount
onMounted(() => {
  fetchOrders();
});




const products = [
  {
    id: 1,
    name: 'Nomad Tumbler',
    description:
      'This durable and portable insulated tumbler will keep your beverage at the perfect temperature during your next adventure.',
    href: '#',
    price: '35.00',
    status: 'Preparing to ship',
    step: 1,
    date: 'March 24, 2021',
    datetime: '2021-03-24',
    address: ['Floyd Miles', '7363 Cynthia Pass', 'Toronto, ON N3Y 4H8'],
    email: 'f•••@example.com',
    phone: '1•••••••••40',
    imageSrc: 'https://tailwindui.com/plus/img/ecommerce-images/confirmation-page-03-product-01.jpg',
    imageAlt: 'Insulated bottle with white base and black snap lid.',
  },
  {
    id: 2,
    name: 'Minimalist Wristwatch',
    description: 'This contemporary wristwatch has a clean, minimalist look and high quality components.',
    href: '#',
    price: '149.00',
    status: 'Shipped',
    step: 0,
    date: 'March 23, 2021',
    datetime: '2021-03-23',
    address: ['Floyd Miles', '7363 Cynthia Pass', 'Toronto, ON N3Y 4H8'],
    email: 'f•••@example.com',
    phone: '1•••••••••40',
    imageSrc: 'https://tailwindui.com/plus/img/ecommerce-images/confirmation-page-03-product-02.jpg',
    imageAlt:
      'Arm modeling wristwatch with black leather band, white watch face, thin watch hands, and fine time markings.',
  },
  // More products...
]
</script>

  
  <style scoped>
  .custom-table th {
    color: #000; /* Black text color */
    font-weight: bold;
    background-color: #f5f5f5; /* Light background for visibility */
  }
  </style>